import React from "react";
import { Button, Typography, Box } from "@mui/material";

const ScheduleModalActions = ({
  selectedDay,
  selectedTime,
  formatSelectedDateTime,
  confirmSchedule,
  isSaveDisabled,
  isLoading,
  isPageLoading = false,
  saveButtonText,
  isCardVerified,
  openVerifyCardModal,
  meetingData,
  isRescheduleMode = false,
}) => {
  const isSessionFree = meetingData?.session?.session_rate === 0;
  const needsPaymentMethod =
    !isRescheduleMode && !isSessionFree && !isCardVerified;
  const isButtonDisabled =
    isPageLoading || isLoading || (isSaveDisabled && !needsPaymentMethod);
  const hasSelectedTime = Boolean(selectedDay && selectedTime);

  const handleButtonClick = () => {
    if (needsPaymentMethod) openVerifyCardModal();
    else confirmSchedule();
  };

  const getButtonText = () => {
    if (isPageLoading) return "Updating";
    if (isLoading) return isRescheduleMode ? "Rescheduling..." : "Sending...";
    if (needsPaymentMethod) return "Add Payment Method";
    return isRescheduleMode ? "Confirm new time" : saveButtonText;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box role="status" aria-live="polite" sx={{ minWidth: 0, "& .MuiTypography-root": { fontSize: "13px" } }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {hasSelectedTime
            ? isRescheduleMode
              ? "New meeting time"
              : "Meeting time"
            : isRescheduleMode
            ? "Choose a new time"
            : "Choose a time"}
        </Typography>
        <Typography
          component="div"
          variant="body2"
          sx={{
            color: "text.primary",
            fontWeight: hasSelectedTime ? 600 : 400,
            mt: 0.5,
          }}
        >
          {isPageLoading
            ? "Loading available times..."
            : hasSelectedTime
            ? formatSelectedDateTime()
            : "Select a date and an available time."}
        </Typography>
        {needsPaymentMethod && (
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
            Add a payment method to book this meeting.
          </Typography>
        )}
      </Box>
      <Button
        variant="text"
        onClick={handleButtonClick}
        disabled={isButtonDisabled}
        sx={{
          minHeight: 48,
          width: { xs: "100%", sm: "auto" },
          px: { xs: 2, sm: 0.5 },
          alignSelf: { xs: "stretch", sm: "flex-end" },
          borderRadius: { xs: "10px", sm: 0 },
          flexShrink: 0,
          fontWeight: 600,
          color: { xs: "background.paper", sm: "text.primary" },
          backgroundColor: { xs: "text.primary", sm: "transparent" },
          "&:hover": {
            backgroundColor: { xs: "text.secondary", sm: "transparent" },
            color: { xs: "background.paper", sm: "text.secondary" },
          },
          "&.Mui-disabled": {
            backgroundColor: { xs: "action.disabledBackground", sm: "transparent" },
            color: "text.disabled",
          },
        }}
      >
        {getButtonText()}
      </Button>
    </Box>
  );
};

export default ScheduleModalActions;
